module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_BE logopaedics content </div> <a href=/nl_BE/store/catalog/logopaedics>Go to catalog</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/views/store/info/nl_BE/logopaedics.jsp
// module id = 680
// module chunks = 3